import { render, staticRenderFns } from "./NotationPage.vue?vue&type=template&id=e66f3bce&scoped=true&"
import script from "./NotationPage.vue?vue&type=script&lang=js&"
export * from "./NotationPage.vue?vue&type=script&lang=js&"
import style0 from "./NotationPage.vue?vue&type=style&index=0&id=e66f3bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66f3bce",
  null
  
)

export default component.exports